module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_video_creation-cb0d70e470dd06443ed625bfe84665fc.svg";